/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

export default {
  year: 'Year {n}',
  choose: 'Choose {n}',
  hello: 'hello {n}',
  store: 'New {n}',
  update: 'Update {n}',
  show: 'Show {n}',
  destroy: 'Delete {n}',
  role_permissions: 'Permissions of {n}',
  yearsOf: 'Years of {n}',
  browse: 'Browse {v}',
  go_to: 'Go To {v}'
}
